import { CoreApi } from "../core/CoreApi";
import { API_ENDPOINTS } from "@libs/request/endpoints_helper";

class CartRequest extends CoreApi {
  getData(input = {}) {
    return this.http
      .get(API_ENDPOINTS.cartInfo, { params: input })
      .then((res) => res.data);
  }
  cartData(input = {}) {
    return this.http
      .get(API_ENDPOINTS.cartData, { params: input })
      .then((res) => res.data);
  }
  getInstallment(input = {}) {
    return this.http
      .get(API_ENDPOINTS.installment, { params: input })
      .then((res) => res.data);
  }

  getDataRemaining(input = {}) {
    return this.http
      .get(API_ENDPOINTS.remaining, { params: input })
      .then((res) => res.data);
  }

  getRooms(input = {}) {
    return this.http
      .get(API_ENDPOINTS.getRooms, { params: input })
      .then((res) => res.data);
  }

  addRoom(input = {}, queryStrings) {
    return this.http
      .post(API_ENDPOINTS.addRoom(this.parserData(queryStrings)), input)
      .then((res) => res.data);
  }
  removeRoom(input = {}, queryStrings) {
    return this.http
      .post(API_ENDPOINTS.removeRoom(this.parserData(queryStrings)), input)
      .then((res) => res.data);
  }

  getExtras(input = {}, queryStrings) {
    return this.http
      .get(API_ENDPOINTS.getExtras(this.parserData(queryStrings)), {
        params: input,
      })
      .then((res) => res.data);
  }
  addExtra(input = {}, queryStrings) {
    return this.http
      .post(API_ENDPOINTS.addExtras(this.parserData(queryStrings)), input)
      .then((res) => res.data);
  }
  removeExtras(input = {}, queryStrings) {
    return this.http
      .post(API_ENDPOINTS.removeExtras(this.parserData(queryStrings)), input)
      .then((res) => res.data);
  }

  getInfo(input = {}, queryStrings) {
    return this.http
      .get(API_ENDPOINTS.getInfo(this.parserData(queryStrings)), {
        params: input,
      })
      .then((res) => res.data);
  }

  submitDataBooking(input = {}, queryStrings) {
    return this.http
      .post(API_ENDPOINTS.submitBooking(this.parserData(queryStrings)), input)
      .then((res) => res.data);
  }

  getCart(input = {}) {
    return this.http
      .get(API_ENDPOINTS.cartInfo, { params: input })
      .then((res) => res.data);
  }

  getSecretPay(input = {}, queryStrings) {
    return this.http
      .post(API_ENDPOINTS.paymentCode(this.parserData(queryStrings)), input)
      .then((res) => res.data);
  }
  getPayLink(input = {}, queryStrings) {
    return this.http
      .post(API_ENDPOINTS.paymentLink(this.parserData(queryStrings)), input)
      .then((res) => res.data);
  }

  getPayKlarna(input = {}, queryStrings) {
    return this.http
      .post(API_ENDPOINTS.paymentKlarna(this.parserData(queryStrings)), input)
      .then((res) => res.data);
  }
  getPaySofort(input = {}, queryStrings) {
    return this.http
      .post(API_ENDPOINTS.paymentSofort(this.parserData(queryStrings)), input)
      .then((res) => res.data);
  }

  getPaymentCheck(input = {}, queryStrings) {
    return this.http
      .post(API_ENDPOINTS.paymentCheck(this.parserData(queryStrings)), input)
      .then((res) => res.data);
  }

  checkInstallmentPayment(input = {}) {
    return this.http
      .post(API_ENDPOINTS.installmentPayCheck(), input)
      .then((res) => res.data);
  }

  getPaypalUrl(input = {}, queryStrings) {
    return this.http
      .post(API_ENDPOINTS.paymentPaypal(this.parserData(queryStrings)), input)
      .then((res) => res.data);
  }

  couponCheck(input = {}, queryStrings) {
    return this.http
      .post(API_ENDPOINTS.couponCheck(this.parserData(queryStrings)), input)
      .then((res) => res.data);
  }

  paymentSubmit(input = {}, queryStrings) {
    return this.http
      .post(API_ENDPOINTS.paymentSubmit(this.parserData(queryStrings)), input)
      .then((res) => res.data);
  }
}
export const CartService = new CartRequest("auth");
